





























































import { computed, defineComponent } from '@vue/composition-api';
import SubmitDialogSubmitting from './submit-dialog/submitting.vue';
import SubmitDialogSuccess from './submit-dialog/success.vue';
import SubmitDialogErrorDesc from './submit-error/error-desc.vue';
import SubmitDialogErrorTable from './submit-error/error-table.vue';
import SubmitDialogErrorBtns from './submit-error/error-btns.vue';
import { useCreationAsyncSubmit } from './hook';
import { CREATION_SUBMIT_ICON } from './const';

export default defineComponent({
  components: {
    SubmitDialogSubmitting,
    SubmitDialogSuccess,
    SubmitDialogErrorDesc,
    SubmitDialogErrorTable,
    SubmitDialogErrorBtns,
  },
  props: {
    customDialogWidth: {
      type: Number,
      default: 0,
    },
    showProgress: {
      type: Boolean,
      default: true,
    },
    isMultipleCountry: {
      type: Boolean,
      default: false,
    },
    is1nn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const {
      visible,
      isSubmitting,
      isSuccess,
      isSubmitFail,
      progress,
      status,
      submitErrorInfo,
      handleClose,
      handleRetry,
      handleFix: handleFixForOldFlow,
      handleFixFor1nn,
    } = useCreationAsyncSubmit(emit);

    const handleFix = data => {
      if (props.is1nn) {
        handleFixFor1nn(data);
      } else {
        handleFixForOldFlow(data);
      }
    };

    const dialogWidth = computed(() => {
      // 成功场景如果传了自定义宽度，则使用自定义宽度
      if (props.customDialogWidth && isSuccess.value) {
        return `${props.customDialogWidth}px`;
      }
      return isSubmitting.value || isSuccess.value ? '480px' : '884px';
    });
    const dialogTitle = computed(() => (isSubmitFail.value ? submitErrorInfo.value.title : ''));

    // 预加载图片，避免加载期间空白的问题
    const AWAIT_TIME = 1000;
    setTimeout(() => {
      try {
        new Image().src = CREATION_SUBMIT_ICON.SUBMITTING;
        new Image().src = CREATION_SUBMIT_ICON.SUCCESS;
      } catch (error) {}
    }, AWAIT_TIME);

    return {
      dialogWidth,
      dialogTitle,

      visible,
      progress,
      status,
      submitErrorInfo,
      handleClose,
      handleRetry,
      handleFix,

      isSubmitting,
      isSuccess,
      isSubmitFail,
    };
  },
});
